"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollType = exports.ElementScrollTrackManage = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var defaultScrollThreshold = 5;
var ScrollType;
exports.ScrollType = ScrollType;
(function (ScrollType) {
  ScrollType["Vertical"] = "Vertical";
  ScrollType["Horizontal"] = "horizontal";
})(ScrollType || (exports.ScrollType = ScrollType = {}));
var TrackElementScroll = /** 需要监听滚动的element */

/** 滚动方向 */
function TrackElementScroll(ele, type, options) {
  var _this = this,
    _this$containerElemen3;
  (0, _classCallCheck2.default)(this, TrackElementScroll);
  (0, _defineProperty2.default)(this, "ele", void 0);
  (0, _defineProperty2.default)(this, "type", void 0);
  (0, _defineProperty2.default)(this, "scrollCallback", void 0);
  (0, _defineProperty2.default)(this, "containerElement", void 0);
  (0, _defineProperty2.default)(this, "trackScrollToEnd", void 0);
  (0, _defineProperty2.default)(this, "scrollToEndCallBack", void 0);
  (0, _defineProperty2.default)(this, "scrollThreshold", void 0);
  (0, _defineProperty2.default)(this, "onTouchStart", function () {
    var containerElement = _this.containerElement;
    var hasMoved = false;
    var startScrollTop = containerElement.scrollTop,
      startScrollLeft = containerElement.scrollLeft,
      scrollHeight = containerElement.scrollHeight,
      offsetHeight = containerElement.offsetHeight,
      scrollWidth = containerElement.scrollWidth,
      offsetWidth = containerElement.offsetWidth;
    var onTouchMove = function onTouchMove() {
      if (_this.type === ScrollType.Vertical) {
        hasMoved = containerElement.scrollTop !== startScrollTop && scrollHeight !== offsetHeight;
      } else if (_this.type === ScrollType.Horizontal) {
        hasMoved = containerElement.scrollLeft !== startScrollLeft && scrollWidth !== offsetWidth;
      }
    };
    var onTouchEnd = function onTouchEnd() {
      var _this$scrollCallback;
      hasMoved && ((_this$scrollCallback = _this.scrollCallback) === null || _this$scrollCallback === void 0 ? void 0 : _this$scrollCallback.call(_this));
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', onTouchEnd);
    };
    window.addEventListener('touchmove', onTouchMove);
    window.addEventListener('touchend', onTouchEnd);
  });
  (0, _defineProperty2.default)(this, "onceScrollToEnd", function () {
    var _ref = _this.containerElement,
      scrollHeight = _ref.scrollHeight,
      offsetHeight = _ref.offsetHeight,
      scrollWidth = _ref.scrollWidth,
      offsetWidth = _ref.offsetWidth,
      scrollTop = _ref.scrollTop,
      scrollLeft = _ref.scrollLeft;
    var scrollToEnd = function scrollToEnd() {
      var _this$scrollToEndCall, _this$containerElemen;
      (_this$scrollToEndCall = _this.scrollToEndCallBack) === null || _this$scrollToEndCall === void 0 ? void 0 : _this$scrollToEndCall.call(_this);
      (_this$containerElemen = _this.containerElement) === null || _this$containerElemen === void 0 ? void 0 : _this$containerElemen.removeEventListener('scroll', _this.onceScrollToEnd);
    };
    if (_this.type === ScrollType.Vertical) {
      if (scrollHeight - offsetHeight - scrollTop <= _this.scrollThreshold) {
        scrollToEnd();
      }
    } else if (_this.type === ScrollType.Horizontal) {
      if (scrollWidth - offsetWidth - scrollLeft <= _this.scrollThreshold) {
        scrollToEnd();
      }
    }
  });
  (0, _defineProperty2.default)(this, "destroy", function () {
    var _this$containerElemen2;
    _this.ele.removeEventListener('touchstart', _this.onTouchStart);
    _this.trackScrollToEnd && ((_this$containerElemen2 = _this.containerElement) === null || _this$containerElemen2 === void 0 ? void 0 : _this$containerElemen2.removeEventListener('scroll', _this.onceScrollToEnd));
  });
  this.ele = ele;
  this.type = type;
  this.scrollCallback = options === null || options === void 0 ? void 0 : options.scrollCallback;
  this.containerElement = (options === null || options === void 0 ? void 0 : options.containerElement) || this.ele.parentElement;
  this.trackScrollToEnd = options === null || options === void 0 ? void 0 : options.trackScrollToEnd;
  this.scrollToEndCallBack = options === null || options === void 0 ? void 0 : options.scrollToEndCallBack;
  this.scrollThreshold = (options === null || options === void 0 ? void 0 : options.scrollThreshold) || defaultScrollThreshold;
  this.ele.addEventListener('touchstart', this.onTouchStart);
  this.trackScrollToEnd && ((_this$containerElemen3 = this.containerElement) === null || _this$containerElemen3 === void 0 ? void 0 : _this$containerElemen3.addEventListener('scroll', this.onceScrollToEnd));
};
var ElementScrollTrackManage = /*#__PURE__*/function () {
  function ElementScrollTrackManage() {
    (0, _classCallCheck2.default)(this, ElementScrollTrackManage);
    (0, _defineProperty2.default)(this, "elementArray", void 0);
    this.elementArray = [];
  }
  (0, _createClass2.default)(ElementScrollTrackManage, [{
    key: "addTrack",
    value: function addTrack(ele, type, options) {
      this.elementArray.push(new TrackElementScroll(ele, type, options));
    }
  }, {
    key: "removeAllTrack",
    value: function removeAllTrack() {
      this.elementArray.forEach(function (item) {
        item.destroy();
      });
    }
  }]);
  return ElementScrollTrackManage;
}();
exports.ElementScrollTrackManage = ElementScrollTrackManage;